module.exports = __webpack_public_path__ + "static/img/img(27).602fb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(27).png
// module id = hnYI
// module chunks = 1